import type { PartShape } from '../utils/partGeometry';

export type CadModel = {
  id: string;
  title: string;
  category: string;
  formats: string[];
  /**
   * Real model file (STL, GLB or GLTF). While empty, a procedural stand-in of `shape` is shown.
   * Replace with the actual files from the CAD-Datenarchiv on konradwalz.com.
   */
  file: string;
  shape: PartShape;
};

// PLACEHOLDERS: the models on konradwalz.com/500-cad-datenarchiv load dynamically and could not be read.
// Titles and parts below are stand-ins — replace with the real archive entries and their files.
export const cadModels: CadModel[] = [
  { id: 'flansch', title: 'Anschlussflansch DN80', category: 'Zerspanung', formats: ['STEP', 'STL'], file: '', shape: 'flange' },
  { id: 'stirnrad', title: 'Stirnrad z = 22', category: 'Antriebstechnik', formats: ['STEP', 'X_T'], file: '', shape: 'gear' },
  { id: 'lagerbock', title: 'Lagerbock geschweißt', category: 'Schweißbaugruppe', formats: ['STEP', 'DXF'], file: '', shape: 'bracket' },
  { id: 'welle', title: 'Abtriebswelle gestuft', category: 'Zerspanung', formats: ['STEP', 'PDF'], file: '', shape: 'shaft' },
  { id: 'riemenscheibe', title: 'Keilriemenscheibe', category: 'Antriebstechnik', formats: ['STEP', 'STL'], file: '', shape: 'pulley' },
  { id: 'montageplatte', title: 'Montageplatte mit Langloch', category: 'Blech / Laser', formats: ['DXF', 'STEP'], file: '', shape: 'plate' },
];
